import { Company } from '~/types/company';
import { Document } from '~/types/document';

export interface PayrollUpload {
  id: string;
  companyId: string;
  creationDate: string;
  url: string;
}

export const PayrollQueryKeys = {
  all: ['Payroll'],
  proposal: (companyId: Company['id'], documentId: Document['id']) => ['Payroll', companyId, 'Proposal', documentId],
};
